export const getLocalStorageItem = (key: string) => {
  return localStorage.getItem(key);
};

export const setLocalStorageItem = (key: string, value: any) => {
  return localStorage.setItem(key, value);
};
export const removeLocalStorageItem = (key: string) => {
  return localStorage.removeItem(key);
};
export const setLocalStorageAccessToken = (token: string) =>
  setLocalStorageItem("accessToken", token);

export const setLocalStorageRefreshToken = (token: string) =>
  setLocalStorageItem("refreshToken", token);

export const removeLocalStorageAccessToken = () =>
  localStorage.removeItem("accessToken");

export const removeLocalStorageRefreshToken = () =>
  localStorage.removeItem("refreshToken");

export const getLocalStorageAccessToken = () =>
  getLocalStorageItem("accessToken");

export const getLocalStorageRefreshToken = () =>
  getLocalStorageItem("refreshToken");

export const setLocalStorageTraceId = (traceId: number) =>
  setLocalStorageItem("traceId", traceId);

export const getLocalStorageTraceId = () => getLocalStorageItem("traceId");

export const removeLocalStorageTraceId = () =>
  localStorage.removeItem("traceId");
